module.exports = __webpack_public_path__ + "img/rubicon_mockup_01.1a65e78a.png";